import { useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import { AiFillHome, AiFillPieChart } from "react-icons/ai";
import { FaUsers, FaBuilding, FaWifi } from "react-icons/fa";
import { TfiAngleLeft } from "react-icons/tfi";

import { AiFillProduct } from "react-icons/ai";
import { IoLogOutSharp, IoSettings } from "react-icons/io5";
import { BiSolidHelpCircle } from "react-icons/bi";
import { IoMdNotifications } from "react-icons/io";

import { AuthContext } from "../../context/auth-context";
import logo from "../../assets/images/logo.png";
import "./style.css";

const Sidebar = () => {
	const { logout } = useContext(AuthContext);
	const location = useLocation();
	const navigate = useNavigate();

	const handleLogout = () => {
		logout();
		navigate("/login");
	};

	return (
		// <div className={`sidebar-wrapper ${sidebarOpen ? "" : "close"}`}>
		<div className="sidebar-wrapper">
			<div className="logo-wrapper">
				<img src={logo} alt="logo" />
				{/* <TfiAngleLeft onClick={() => setSidebarOpen(true)} /> */}
				<TfiAngleLeft />
			</div>
			<div className="menu-wrapper">
				<NavLink
					to="/"
					className={({ isActive }) =>
						`side-menu ${isActive || location.pathname === "/" ? "active" : ""}`
					}
				>
					<AiFillHome />
					<span>Ana Ekran</span>
				</NavLink>
				<NavLink
					to="/user-list"
					className={({ isActive }) =>
						`side-menu ${isActive || location.pathname.startsWith("/user-list") ? "active" : ""}`
					}
				>
					<FaUsers />
					<span>Üyeler</span>
				</NavLink>
				<NavLink
					to="/devices"
					className={({ isActive }) =>
						`side-menu ${isActive || location.pathname.startsWith("/devices") ? "active" : ""}`
					}
				>
					<FaWifi />
					<span>Cihazlar</span>
				</NavLink>
				<NavLink
					to="/producers"
					className={({ isActive }) =>
						`side-menu ${isActive ? "active" : ""}`
					}
				>
					<AiFillProduct />
					<span>Üreticiler</span>
				</NavLink>
				<NavLink
					to="/organizations"
					className={({ isActive }) =>
						`side-menu ${isActive || location.pathname.startsWith("/organizations") ? "active" : ""}`
					}
				>
					<FaBuilding />
					<span>Kurumlar</span>
				</NavLink>
				<NavLink
					to="/notification-center"
					className={({ isActive }) =>
						`side-menu ${isActive ? "active" : ""}`
					}
				>
					<IoMdNotifications />
					<span>Bildirim Merkezi</span>
				</NavLink>
				<NavLink
					to="/login-detail"
					className={({ isActive }) =>
						`side-menu ${isActive ? "active" : ""}`
					}
				>
					<IoSettings />
					<span>Ayarlar</span>
				</NavLink>
				<div className="side-menu" onClick={handleLogout} style={{ cursor: "pointer" }}>
					<IoLogOutSharp />
					<p>Çıkış Yap</p>
				</div>
				<div className="side-menu">
					<BiSolidHelpCircle />
					<a href="#">Yardım</a>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
